module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerRoman-d1a9e8da2a97394bc95c440ee5cde447.ttf";